// Public env vars (Vite exposes only VITE_ prefixed ones to the bundle).
// Copy .env.example to .env and fill in your Supabase project values.

export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL as string
export const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY as string

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  // Don't crash the app during pure-static preview without a backend —
  // surface a console warning so auth/data calls fail predictably instead.
  // eslint-disable-next-line no-console
  console.warn(
    '[bitutravel] Missing VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY. ' +
      'Copy .env.example to .env and fill in your Supabase project values.',
  )
}

export const APP_NAME = 'bitutravel'

export const SUPPORTED_LOCALES = [
  'es',
  'ca',
  'eu',
  'gl',
  'en',
  'de',
  'fr',
  'it',
  'pt',
] as const
export type Locale = (typeof SUPPORTED_LOCALES)[number]
// English is the default when the device language can't be matched to one of
// our 9 supported locales — so a first-time visitor abroad lands on English,
// not Spanish.
export const DEFAULT_LOCALE: Locale = 'en'